import React, {Component} from "react";
import Barcode from "jsbarcode";


class BarCode extends Component {

    barcode = null;

    componentDidMount () {
        this.createBarcode()
    }

    createBarcode = () => {
        const {value, ...otherProps} = this.props;
        value && Barcode(this.barcode, value, otherProps)
    };

    render () {
        return this.props.value ? (
            <svg ref={ref => this.barcode = ref} alt={''}/>
        ) : null;
    }
}

export default BarCode;